module.exports = __webpack_public_path__ + "static/media/book-bqdj.e6b310aa.png";